import { EditorStarterItem } from '../items/item-type';
import { getTrackHeight, TRACK_DIVIDER_HEIGHT } from '../state/items';
import { TrackType } from '../state/types';
import { getZoneBoundaryIndex, ZONE_SEPARATOR_HEIGHT } from './zone-utils';

export const getOffsetOfTrack = ({
  trackIndex,
  tracks,
  items,
}: {
  trackIndex: number;
  tracks: TrackType[];
  items: Record<string, EditorStarterItem>;
}) => {
  const zoneBoundaryIndex = getZoneBoundaryIndex(tracks);

  return tracks.slice(0, trackIndex).reduce((acc, track, index) => {
    const shouldInsertZoneSeparator =
      zoneBoundaryIndex > 0 &&
      zoneBoundaryIndex < tracks.length &&
      index === zoneBoundaryIndex - 1;

    return (
      acc +
      getTrackHeight({ track, items }) +
      TRACK_DIVIDER_HEIGHT +
      (shouldInsertZoneSeparator ? ZONE_SEPARATOR_HEIGHT : 0)
    );
  }, 0);
};

export const getFromFromLeft = ({
  timelineWidth,
  left,
  totalDurationInFrames,
}: {
  timelineWidth: number;
  left: number;
  totalDurationInFrames: number;
}) => {
  return Math.round((left / timelineWidth) * (totalDurationInFrames - 1));
};

export const getItemLeftOffset = ({
  timelineWidth,
  totalDurationInFrames,
  from,
}: {
  timelineWidth: number;
  totalDurationInFrames: number;
  from: number;
}) => {
  return (from / totalDurationInFrames) * timelineWidth;
};

export const getItemWidth = ({
  itemDurationInFrames,
  timelineWidth,
  totalDurationInFrames,
}: {
  itemDurationInFrames: number;
  timelineWidth: number;
  totalDurationInFrames: number;
}) => {
  return (itemDurationInFrames / totalDurationInFrames) * timelineWidth;
};

export const getItemRoundedPosition = (
  timelineItemLeft: number,
  timelineItemWidth: number,
) => {
  const roundedLeft = Math.round(timelineItemLeft);
  const roundedDifference = roundedLeft - timelineItemLeft;
  const width = timelineItemWidth - roundedDifference;
  return { roundedLeft, width, roundedDifference };
};

const shouldShowItemHeaderMap: Record<EditorStarterItem['type'], boolean> = {
  audio: true,
  gif: true,
  webp: true,
  image: true,
  video: true,
  pdf: true,
  ppt: true,
  captions: false,
  solid: false,
  blur: false,
  text: false,
  code: false,
  group: false,
};

export const shouldShowItemHeader = (item: EditorStarterItem) => {
  return shouldShowItemHeaderMap[item.type];
};
